import { type CommentUser, NO_AUTHOR } from "@core-ui/CommentBlock";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";

/**
 * Who signs the comment being written: the catalog's account. Without one a local install runs under
 * the placeholder "Admin", which must not sign a review, so there is no name until `author-resolved`.
 */
const useCurrentAuthor = (): CommentUser => {
	const catalogUser = useCatalogPropsStore((state) => state.data?.userInfo);
	const { user, isLogged } = PageDataContextService.value;
	return catalogUser ?? (isLogged ? user.info : null) ?? NO_AUTHOR;
};

export default useCurrentAuthor;
